import React, { useState } from 'react';
import Transaction from './Transaction';
import transactionData from './transactionData';


const Transactions = () => {

  const [transactions, setTransactions] = useState(transactionData)
  const transactionElement = transactions.map(transaction => (
    <Transaction 
      key={transaction.id}
      price={transaction.price}  
      owner={transaction.owner}
      currency={transaction.currency}
      action={transaction.action}
      negotiation={transaction.negotiation}
    />
  ))


  return (
    <div className='inner__page'>
        <div className="transactions">
        <h3 className="inner__page_title">Transaction details</h3>

          <table>
            <thead>
              <tr>
                <th>Currency</th>
                <th>Price/Qty</th>
                <th>Owner</th>
                <th>Negotiation</th>
                <th>Action</th>
              </tr>
            </thead>
             {transactionElement}
          </table>
          
        </div>
    </div>
  )
}

export default Transactions